<script setup>
import { ref } from 'vue'

defineProps({
  contentClasses: String
})

const contentRef = ref(null)

const emit = defineEmits(['popup-close'])

function closePopup(event) {
  if (contentRef.value && !contentRef.value.contains(event.target)) {
    emit('popup-close')
  }
}
</script>

<template>
  <div
    class="szw-absolute szw-top-0 szw-left-0 szw-h-full szw-w-full szw-bg-black/40 szw-text-text-icon-primary szw-z-50 szw-flex szw-justify-center szw-items-center"
    @click="closePopup"
  >
    <div ref="contentRef" :class="contentClasses" @click.stop>
      <slot />
    </div>
  </div>
</template>
